import React from 'react'
import styles from './PageHeader.module.scss'

const PageHeader = ({ title, children, subtitle }) => (
  <div className={styles.pageHeader}>
    <div className={styles.titleBlock}>
      <h1 className={styles.title}>{title}</h1>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
    {children}
  </div>
)

export default PageHeader
